import { email } from "@vee-validate/rules";
const getEmailList = (emails) => {
  return emails.split(/[,;|]/).map((email2) => email2.trim()).filter((email2) => email2 !== "");
};
const emailListValidator = (value) => {
  if (!value || !value.length) {
    return true;
  }
  const emails = getEmailList(value);
  return email(emails);
};
export {
  emailListValidator
};
//# sourceMappingURL=email-list.es.js.map
